import type { FC } from "react";
import styled from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { ContactItemLayout } from "../styles";
import type { IIconsButtonProps } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";
import type { SWReactIconProps } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";

export const StyledIconButton = styled<FC<IIconsButtonProps>>(IconButton)`
    opacity: 0;
    transition: opacity 0.2s ease-in-out;

    &:hover {
        background: transparent;
    }
`;

export const StyledContactListItem = styled.div`
    padding: 30px 16px 16px 24px;
    background-color: ${colorsPalettes.carbon[0]};
    transition: background-color 0.2s ease-in-out;
    ${ContactItemLayout}

    &:not(:last-child) {
        border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    }

    &:hover {
        background-color: ${colorsPalettes.carbon[25]};
    }

    &:hover ${StyledIconButton} {
        opacity: 1;
    }
`;

export const StyledContactListItemDisabled = styled(StyledContactListItem)`
    background-color: ${colorsPalettes.carbon[25]};
`;

export const StyledContactInfo = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledContactName = styled.div`
    display: flex;
    ${mixins.setFont({
        $size: 14,
        $weight: 500,
        $color: colorsPalettes.carbon[400],
    })};
    line-height: 16px;
    margin-bottom: 4px;
`;

export const StyledContactDetails = styled.div`
    display: flex;
    flex-direction: column;

    ${mixins.setFont({
        $size: 14,
        $weight: 400,
        $color: colorsPalettes.carbon[400],
    })};

    line-height: 16px;
`;

export const StyledCompanyName = styled.span`
    span {
        ${mixins.setFont({ $weight: 500 })}
    }
`;

export const StyledAlertIcon = styled(SWReactIcons).attrs<Partial<SWReactIconProps>>(({ size }) => ({
    iconName: "alert-circle",
    size: size ?? "xs",
}))<Omit<SWReactIconProps, "iconName" | "size">>`
    flex-grow: 0;
    flex-shrink: 0;
    margin-left: 8px;
    svg {
        path {
            fill: ${colorsPalettes.red["s100"]};
        }
    }
`;
